<template>
  <div id="aniversario">

    <header>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="logo">
              <!-- <a href="/"><img :src="logo" /></a> -->
            </div>
          </div>

          <div class="col-md-8 offset-md-2 offset-sm-0">
            <div class="form">
              <h1>Você recebeu um Convite do Bem! Sua presença é muito importante, venha celebrar conosco.</h1>
              <span v-if="invite">{{invite.email}} lhe enviou este convite. Confira abaixo os detalhes e não deixe de confirmar a sua presença!</span>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div id="main">
      <div class="container">
        <div class="row">
          <div class="intro col-md-12" v-if="invite">
            <div class="base">
              <div class="content">
                <h2>{{invite.title}}</h2>
                <h3>Local: {{invite.local}}</h3>
                <h4>Data: {{invite.date}}</h4>
                <p>Horário: {{invite.hour}}</p>
                <p>Endereço: {{invite.address}}</p>
                <button @click.stop.prevent="openMaps()">Ver no Mapa</button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form col-md-12" v-if="project">
            <div class="content">
              <h5>"{{invite.description}}".</h5>
              <span>Este é um Convite do Bem! O organizador do evento solicita que os valores referentes à eventuais presentes sejam revertidos para o Projeto Social que foi escolhido por ele.</span>
              <div v-if="msgShow" class="alert alert-danger alert-dismissible fade show" role="alert">
                {{msg}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" @click.stop.prevent="hideMsg()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <button @click.stop.prevent="donate()">Pague com PayPal</button>
            </div>
            <div class="project">
                <span>A doação irá para o projeto</span>
                <h3>{{project.Info.title}}</h3>

                <div class="project-container row">
                  <div class="col-md-4">
                    <img :src="project.Info.image"/>
                  </div>
                  <div class="col-md-8">
                    <p class="description mt-2">
                    {{normalizeHtml(project.Info.description)}}
                    </p>
                    <!-- <p>
                      <a class="link-project" :href="'/project/' + project.slug" target="_blank">Clique para conhecer!</a>
                    </p> -->
                  </div>
                </div>
              </div>
          </div>
        </div>

      </div>
    </div>

    <footer>
      <div class="container">
        <div class="row">
          <div class="col-md-4 description">
            <h2>Conheça alguns Projetos Sociais cadastrados em nossa plataforma!</h2>
            <p>Escolha um projeto que toca seu coração e transforme vidas Faça do seu evento um momento de transformação social.</p>
          </div>
        </div>

        <div class="row" v-if="projects">
          <div class="col-md-12">
            <carousel :perPage="perPage" :navigationEnabled="navigationEnabled" :paginationEnabled="paginationEnabled" :autoplay="autoPlay">

              <slide v-for="(p, k) in projects" :key="k" @click="openProject(p.slug)">
                <div class="image">
                  <img :src="p.Info.image" />
                </div>
                <span v-if="p.Categories[0] && p.Categories[0].name">{{p.Categories[0].name}}</span>
                <h3>{{p.Info.title}}</h3>
                <p>{{p.Info.shortDescription}}</p>
              </slide>

            </carousel>
          </div>
        </div>
      </div>

      <div class="base">
        <!-- <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="company">
                <p><b>Click2Giv Serviços Online Ltda.</b> - CNPJ 12.636.988/0001-12</p>
              </div>
              <div class="contact">
                <p><b>suporte@click2giv.com - (11) 98741-1000</b></p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </footer>

    <b-modal :ok-only="true" size="md" ok-title="Processar Doação" id="userDataModal" ref="userDataModal" title="Informe um valor a ser doado" @ok="submitFormDonation">
      <form method="post" class="donationForm" ref="formPayment">

        
        <div class="row">

          <div class="col-md-12">
            <div class="form-group">
              <label>Valor de Doação</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">R$</span>
                </div>
                <input required type="text" v-money="money" name="value" placeholder="Informe o valor que deseja doar para o projeto" v-model="donationValue" class="form-control input-value"/>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Mensagem</label>
              <input type="text" name="message" placeholder="Escreva uma mensagem para a equipe do projeto" v-model="donationMessage" class="form-control"/>
            </div>
          </div>

        </div>
        <div v-if="donationModalMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
          {{donationModalMsg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

      </form>
    </b-modal>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import logo from '../../assets/images/logo_black.png';
import Functions from '../../utils/functions';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faChevronCircleUp} from '@fortawesome/fontawesome-free-solid';
import Loading from '../includes/Loading';
import { API } from '../../services/api';
import { Carousel, Slide } from 'vue-carousel';
import {VMoney} from 'v-money';

export default {
  name: 'Home',
  directives: {money: VMoney},
  components: {
    FontAwesomeIcon,
    Carousel,
    Slide,
    Loading
  },
  data () {
    return {
      loading: false,
      projects: null,
      categories: null,
      logo: logo,
      project: null,
      invite: null,
      user: null,
      msg: '',
      msgShow: false,
      donationModalMsg: '',
      donationValue: 0,
      integralDonationValue: 0,
      donationMessage: '',
      donationModalMsgShow: false,
      perPage: 4,
      navigationEnabled: true,
      paginationEnabled: true,
      autoPlay: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  created(){
    this.loadInvite();
    this.loadProjects();
  },
  mounted (){
    if(window.innerWidth < 415){
      this.perPage = 1
      this.navigationEnabled = false
      this.paginationEnabled = false
      this.autoPlay = true
    }
  },
  methods: {
    loadInvite(){
      var inviteId = this.$route.params.invite;
      this.$http.get(API.Invite.get + inviteId).then((result) => {
        this.invite = result.body.invite;
        this.project = result.body.project;
      });
    },
    loadProjects(){
      this.$http.get(API.Projects.projects).then((result) => {
        this.projects = result.body;
        var featuredProjects = this.projects.filter((e) => {
          return (e.isFeatured) && e.Categories[0].name;
        });
        featuredProjects = Functions.arrayShuffle(featuredProjects)
        featuredProjects.splice(8, featuredProjects.length - 8);
        this.projects = featuredProjects
      });
    },
    donate(){
      this.$refs.userDataModal.show();
    },
    submitFormDonation(e)
    {
      e.preventDefault();
      this.loading = true;
      var donationValueText = parseFloat(this.donationValue.replace(".", "").replace(",", "."));
      this.integralDonationValue = (donationValueText > 0.0) ? donationValueText : this.donationValue;
      if(this.integralDonationValue && this.donationMessage && this.donationMessage != ''){
        this.$refs.userDataModal.hide();
        this.$http.post(API.Invite.registerDonation, {
          ProjectId: this.invite.ProjectId,
          InviteId: this.invite.InviteId,
          donationValue: this.integralDonationValue,
          message: this.donationMessage,
        }).then((res) => {
          this.loading = false;
          var DonationId = res.body.DonationId;
          this.methodPagarme(DonationId);
        });
      }else{
        this.loading = false;
        this.donationModalMsg = 'Você deve definir um valor e uma mensagem para a doação!';
        this.donationModalMsgShow = true;
      }
    },
    methodPagarme(DonationId){
      var $this = this;
      // inicia a instância do checkout
      var checkout = new PagarMeCheckout.Checkout({
        encryption_key: 'ek_live_eMgIJ1T98Ru5U0K8hDHHkwRp8yLisM',
        // encryption_key: 'ek_test_BGBezpiqx7ZKxMAvh2d7azSUDrNZBo',
        success: function(data) {
          $this.loading = true;
          var params = {paymentMethod: data.payment_method, token: data.token};
          $this.$http.post(API.Invite.processPayment + DonationId, params).then((res) => {
            var donation = res.body.donation;
            var postback = JSON.parse(donation.postback);
          }, (error) => {
            if(error.body.message){
              $this.msg = error.body.message;
            }else{
              $this.msg = 'Ocorreu um erro no processamento do seu pagamento. Tente novamente.';
            }
            $this.msgShow = true;
            $this.loading = false;
          });
        },
        error: function(err) {
          console.log("ERROR")
          console.log(err)
        },
        close: function() {
          console.log('The modal has been closed.');
        }
      });

      // Obs.: é necessário passar os valores boolean como string
      checkout.open({
        amount: this.integralDonationValue.value * 100,
        buttonText: 'Pagar',
        buttonClass: 'botao-pagamento',
        customerData: 'true',
        createToken: 'false',
        paymentMethods: 'credit_card, boleto',
        uiColor: '#00AE39',
        postbackUrl: API.Invite.processNotification + DonationId,
        items: [{
          "id": DonationId,
          "title": "Doação para " + $this.project.Info.title,
          "unit_price": $this.integralDonationValue + '00',
          "quantity": 1,
          "tangible": "false"
        }]
      });
    },
    openMaps()
    {
      window.open('http://maps.google.com/?q=' + this.invite.address, '_blank');
    },
    openProject(slug){
      this.$router.push({path: '/project/' + slug});
    },
    normalizeHtml(text)
    { 
      text = text.replace(/<\/?[^>]+(>|$)/g, "");
      text = text.replace(/&nbsp;/g," ");
      return text;
    },
    hideMsg(){
      this.msgShow = false;
      this.msg = "";
      this.donationModalMsg = "";
      this.donationModalMsgShow = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

h1{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 44px;
  line-height: 45px;
  letter-spacing: -0.04em;
  color: #333;
}

h2{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 35px;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: #333;
}

h3{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 25px;
  line-height: 25px;
  letter-spacing: -0.01em;
  color: #333;
}

h5{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -0.01em;
  color: #333;
}

header{
  width: 100%;
  display: block;
  height: 650px;
  background: url('../../assets/images/bkg-top-aniversario.jpg') bottom center;

  .logo{
    margin-top: 50px;
  }

  .form{
    margin-top: 100px;

    span{
      font-family: Rubik;
      color: #333;
      margin-top: 10px;
      width: 80%;
      display: block;
    }

  }
}

#main{
  width: 100%;
  display: block;
  min-height: 1400px;
  padding-bottom: 100px;
  position: relative;

  .intro{

    .base{
      height: 30px;
      width: 100%;
      position: relative;
    }

    .content{
      width: 100%;
      text-align: center;
      position: absolute;
      top: -150px;

      span{
        font-family: Rubik;
        color: #333;
      }

      button{
        width: 50%;
        height: 60px;
        color: #fff;
        background-color: #FB101F;
        border: none;
        border-radius: 10px;
        padding-left: 20px;
        padding-right: 20px;
        cursor: pointer;
        font-family: Rubik;
        display: block;
        margin: 0 auto;
      }
    }
  }

  .form{
    margin-top: 100px;
    background-color: #F2F7F5;
    padding: 50px;
    text-align: center;
    border-radius: 20px;
    border: 1px dashed #00AE39;
    box-sizing: border-box;

    .content{
      max-width: 500px;
      margin: 0 auto;

      span{
        font-family: Rubik;
        margin-top: 10px;
        display: block;
      }
    }

    button{
      margin-top: 10px;
      background-color: #003087;
      padding: 20px;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      border-radius: 5px;
      text-decoration: none;
      cursor: pointer;
    }

    .project{
      margin-top: 40px;

      .link-project{
        display: block;
        padding: 20px;
        border: thin solid #ccc;
        background-color: #fff;
        color: #00AE39;
        font-family: Rubik;
        border-radius: 20px;
        width: 50%;
        margin: 0 auto;
        margin-top: 20px;
        text-decoration: none;
        font-size: 22px;
      }
    }

    .project-container{
      margin-top: 20px;

      .description{
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
      }

      img{
        width: 100%;
      }
    }

  }

  .about{
    margin-top: 60px;

    p{
      margin-top: 20px;
      font-family: Rubik;
      color: #333;
    }
  }
}

footer{
  width: 100%;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  height: 690px;
  background-color: #F2F7F5;
  border-top: 1px dashed #00AE39;

  .description{
    margin-top: 50px;
  }

  .VueCarousel-slide{
    height: 400px;
    padding-right: 20px;

    .image{
      width: 100%;
      height: 130px;
      border-radius: 10px;
      overflow: hidden;

      img{
        width: 100%;
      }
    }

    h3{
      font-size: 20px;
    }

    span{
      color: #00AE39;
      font-size: 14px;
      font-family: Rubik;
      margin-top: 10px;
      display: block;
    }

    p{
      font-family: Rubik;
      font-size: 14px;
      display: block;
      margin-top: 10px;
    }
  }

  .base{
    width: 100%;
    height: 50px;
    background-color: #fff;
    border-top: 1px dashed #00AE39;
    position: absolute;
    bottom: 0;

    .company{
      float: left;
      margin-top: 15px;

      p{
        font-family: Rubik;
      }

      b{
        font-weight: bold;
      }
    }

    .contact{
      float: right;
      margin-top: 15px;

      p{
        font-family: Rubik;
      }
    }
  }
}

.donationForm{
  .input-group-text{
    padding: 20px;
    background-color: #00AE39;
    border-color: #00AE39;
    color: #fff;
  }
  .input-value{
    padding: 32px;
    padding-left: 10px;
    font-size: 20px;
  }

}

@media screen and (max-width: 414px) {

  header{
    height: 700px;
    background-position: left bottom;

    .logo{
      text-align: center;
    }

    .form{
      margin-top: 40px;
      text-align: center;

      h1{
        font-size: 26px;
      }

      span{
        width: 100%;
      }
      form{
        .input{
          width: 100%;

          button{
            right: 0px;
            font-size: 14px;
          }
        }
      }
    }
  }

  #main{
    margin-top: 50px;
    padding-bottom: 400px;

    .intro{
      .content{
        text-align: center;
      }
    }

    .form{
      margin-top: 200px;
      .input{
          width: 100%;

        button{
          right: 0px;
          font-size: 14px;
        }
      }
    }
  }

  footer{
    height: 740px;
    .VueCarousel-slide{
      padding: 20px;
    }

    .description{
      text-align: center;
    }

    .base{
      height: auto;

      .company, .contact{
        float: none;
        text-align: center;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/aniversariodobem/AniversarioInvite.vue